<template>
  <div />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useActions, useState, useStore } from 'vuex-composition-helpers'
import { SET_INVOICE_DATA_LAST_FETCHED } from '@/store/mutations'

const CACHE_TTL_MS = 300000

const store = useStore()
const { invoiceDataLastFetched } = useState(['invoiceDataLastFetched'])
const { fetchJobData } = useActions(['fetchJobData'])

onMounted(() => {
  if (
    invoiceDataLastFetched.value != null &&
    Date.now() - invoiceDataLastFetched.value < CACHE_TTL_MS
  )
    return

  Promise.all([fetchJobData()]).then(() => {
    store.commit(SET_INVOICE_DATA_LAST_FETCHED, Date.now())
  })
})
</script>
